module.exports = __webpack_public_path__ + "img/fill-white-back.48f870cb.svg";